// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputWithClick {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 16px;
  padding-left: 16px;
  background-color: #ffffff;
  width: 100%;
  font-size: 16px;
  font-family: "Montserrat Regular";
  border-radius: 8px;
  border: 1px solid #E3E3E3;
}
.InputWithClick.error {
  border: 1px solid #eb5757;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/EstablishmentsCreatePage/InputWithClick/InputWithClick.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,yBAAA;AAAF;AAEE;EACE,yBAAA;AAAJ","sourcesContent":["\r\n.InputWithClick {\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  padding-right: 16px;\r\n  padding-left: 16px;\r\n  background-color: #ffffff;\r\n  width: 100%;\r\n  font-size: 16px;\r\n  font-family: 'Montserrat Regular';\r\n  border-radius: 8px;\r\n  border: 1px solid #E3E3E3;\r\n\r\n  &.error {\r\n    border: 1px solid #eb5757;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"InputWithClick": `InputWithClick`,
	"error": `error`
};
export default ___CSS_LOADER_EXPORT___;
